import { useState, useEffect } from 'react';

import Link from 'next/link';

import { TrendingCategoriesProps } from '../../types/components/products/TrendingCategories';
import { CategoryResponse } from '../../types/api/CategoriesIndexTypes';

const TrendingCategories: React.FC<TrendingCategoriesProps> = ({
  allCategories,
  trendingCategoriesResults,
}) => {
  const [trendingCategories, setTrendingCategories] = useState<CategoryResponse[]>([]);

  useEffect(() => {
    if (!allCategories || !trendingCategoriesResults) return;
    setTrendingCategories(allCategoriesAndSubcategories().filter(c => {
      if (!trendingCategoriesResults?.length) return false;
      // the facetValue attribute in the trendingCategories hits equals to a category name
      const hits = trendingCategoriesResults[0].hits || [];
      return hits.map(h => h.facetValue).includes(c.name);
    }));
  }, [allCategories, trendingCategoriesResults]);

  const allCategoriesAndSubcategories = (): Array<CategoryResponse> => {
    const ret = [];
    if (!allCategories) return ret;
    allCategories.forEach(category => {
      ret.push(category);
      if (category.subcategories)
        category.subcategories.forEach(subCategory => {
          const { id, name, slug } = category;
          if (!subCategory.parent) subCategory.parent = { id, name, slug };
          ret.push(subCategory);
        });
    });
    return ret;
  };

  return (
    <div className="hidden mt-5 xl:block">
      <label className="text-[14px] text-[#858788]">Trending:</label>
      {trendingCategories.map(category => {
        const slug = category.parent ? `${category.parent.slug}--${category.slug}` : category.slug;
        return (
          <Link
            key={category.slug}
            className="px-4 py-2 bg-[rgb(255,255,255)] bg-opacity-10 hover:bg-opacity-[.15] mx-2 rounded-3xl text-[#AEB6BA] text-[14px] whitespace-nowrap"
            href={`/collections/${slug}/category`}
          >
            <span>{category.name}</span>
            {category.total_elements > 0 && (
              <span className="ml-2 text-gray-600 text-[12px]">{category.total_elements}</span>
            )}
          </Link>
        )
      })}
    </div>
  );
}

export default TrendingCategories;
